<template>
  <div class="search-result-wrap">
    <div class="mobile-close-content" v-if="isMobileSize">
      <span>{{ $t('tokenSearch') }}</span>
      <img :src="closeImg" @click="$mitt.emit('mobile-search-view', false)" alt="">
    </div>
    <div class="search-result-content flex-1-1-h">
      <!-- :class="{ data: swapMarketSearchInput }" -->
      <div class="search-input-wrap">
        <SearchInput
          v-if="searchTokensVisible"
          @getInputVal="onSearchHistoryKey"
          :value="swapMarketSearchInput"
          :placeholder="$t('searchTokens')"
          focus
        />
      </div>
      <div class="tokens flex-1-1-h" v-if="!swapMarketSearchInput">
        <div
          class="recent-search-list"
          ref="recentSearchList"
          v-if="searchHistoryKeys && searchHistoryKeys.length"
        >
          <RecentSearch
            :searchHistoryKeys="searchHistoryKeys"
            @delete="onDelete"
            @key="onSearchHistoryKey"
          />
        </div>
        <div class="tokens-title popular">{{ $t("popularTokens") }}</div>
        <SearchOptionsHeader isExtra />
        <div
          v-if="hotTokenList.length"
          class="token-list popular-token-list hidden-scrollbar flex-1-1-h"
        >
          <SearchTokenItem
            v-for="(token, index) in hotTokenList"
            :key="`${token.address}-${index}`"
            @onOptional="onOptional"
            @selectSearchedToken="selectSearchedToken"
            :token="token"
          />
        </div>
        <div
          class="loading-no-data-content flex-1-1-h"
          v-else-if="loadingHotToken"
        >
          <div class="loading-wrap">
            <Spinner />
          </div>
        </div>
        <div
          v-else
          class="loading-no-data-content tokens-no-data flex-1-1-h"
        >
          <NoData :isImg="false">
            <img class="no-data-img" :src="searchEmptyImg" alt="" />
          </NoData>
        </div>
      </div>
      <div
        class="tokens hidden-scrollbar flex-1-1-h"
        :class="{ data: swapMarketSearchInput }"
        v-else
      >
        <div
          class="loading-no-data-content flex-1-1-h"
          v-if="swapMarketSearchStatus === 'loading'"
        >
          <div class="loading-wrap">
            <Spinner />
          </div>
        </div>
        <div
          v-else-if="swapMarketSearchStatus === 'noData'"
          class="loading-no-data-content tokens-no-data flex-1-1-h"
        >
            <NoData :isImg="false" :label="$t('noSearchContent')">
            <img class="no-data-img" :src="searchEmptyImg" alt="" />
          </NoData>
        </div>
        <div v-else-if="swapMarketSearchStatus === 'data'">
          <div
            v-for="(key, index) in Object.keys(swapMarketTokenMap)"
            :key="`search-network-${index}`"
          >
            <div class="tokens-title">{{ key }}</div>
            <SearchOptionsHeader />
            <div class="token-list result-token-list">
              <SearchTokenItem
                v-for="(token, index) in swapMarketTokenMap[key]"
                :key="`${token.address}-${index}`"
                marketValueList
                @onOptional="onOptional"
                @selectSearchedToken="selectSearchedToken"
                :token="token"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SearchTokenItem from "../common/SearchTokenItem.vue";
import SearchInput from "../common/SearchInput.vue";
import RecentSearch from "../common/RecentSearch.vue";
import Spinner from "../loading/Spinner.vue";
import SearchOptionsHeader from "./SearchOptionsHeader.vue";
import NoData from "../common/NoData.vue";

import searchHistory from "../../mixins/searchHistory";

// import { CHAIN_INFO_MAP } from "../../constants";

export default {
  props: {
    searchTokensVisible: {
      type: Boolean
    }
  },
  components: { Spinner, SearchTokenItem, SearchInput, RecentSearch, SearchOptionsHeader, NoData },
  data() {
    return {
      swapMarketSearchStatus: "",
      swapMarketSearchInput: "",
      swapMarketTokenMap: [],
      debouncerSearch: null,
      recentSearchListHeight: 0,
      offsetHeight: 0
    };
  },
  mixins: [searchHistory],
  computed: {
    ...mapGetters([
      "isDarkMode",
      "isMobileSize",
      "localOptionalList",
      "utc_type",
      "deviceSize"
    ]),
    closeImg() {
      return require(`../../assets/dialog/close-modal${this.darkModeImg}.png`);
    },
  },
  watch: {
    searchTokensVisible: {
      handler(val) {
        if (val) {
          this.hotTokenList = [];
          this.searchHistoryKeys = this.getSearchHistoryKeys()
          this.getHotSwapTokens();
        } else {
          this.swapMarketSearchInput = "";
        }
      },
      immediate: true
    },
  },
  created() {},

  methods: {
    selectSearchedToken(info) {
      this.$mitt.emit("set-search-token-info", { ...info, isSearch: true });
      // this.setSearchHistoryTokens(info); // 统一在 swap.js selectSearchedToken 方法里面处理
      let address = info.address;
      let moveAddress = info.address;
      // if (
      //   CHAIN_INFO_MAP[info.network] &&
      //   CHAIN_INFO_MAP[info.network].isMoveAddress
      // ) {
      //   address = info.address + "::" + info.bl_symbol;
      // }
      if (this.isMobileSize && this.$route.path === "/market") {
        info.address = moveAddress;
        info.price = info.price_usd;
        this.$router.push({
          path: "/marketToken",
          query: { ...info, isSearch: true }
        });
      } else {
        if (this.$route.path == "/market") {
          this.$router.push({
            path: "/",
            // query: { ...info, isSearch: true }
            query: {
              network: info.network,
              address: address,
              symbol: info.symbol,
              bl_symbol: info.bl_symbol,
              blockchain_id: info.blockchain_id
            }
          });
        }
      }
    },
  }
};
</script>

<style lang="less" scoped>
.search-result-wrap {
  .search-result-content {
    max-width: 960px;
    height: calc(100vh - 240px);
    max-height: 600px;
    overflow-y: auto;
    border-radius: 12px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .search-input-wrap {
      margin-top: 20px;
      padding: 0 20px;
      /deep/ .search-input {
        background: var(--bg-15);
        padding: 0 8px;
        .input-wrap {
          input {
            &::placeholder {
              color: var(--input-placeholder-1);
            }
          }
        }
      }
      &.data {
        margin-bottom: 10px;
      }
    }

    .token-list {
      border-radius: 0 0 20px 20px;
      margin-top: 8px;
      .search-token-item {
        padding: 10px 20px;
        &:hover {
          background: var(--hover-bg-1);
        }
      }
    }

    .popular-token-list {
      overflow-y: auto;
    }

    .tokens {
      flex: 1 1;
      min-height: 0;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
    
      .recent-search-list {
        margin-top: 20px;
        padding: 0 20px;
      }
      .tokens-title {
        margin: 20px 0 0 0;
        font-weight: 600;
        font-size: 16px;
        padding: 0 20px;
        color: var(--color-29);
      }

      .tokens-no-data {
        flex-direction: column;
        img {
          width: 64px;
          height: 64px;
        }

        .content {
          font-size: 12px;
          margin-top: 10px;
          color: var(--color-27);
        }
      }
    }

    .loading-no-data-content {
      display: flex;
      align-items: center;
      justify-content: center;
      .loading-wrap {
        width: 24px;
        height: 24px;
      }
    }
  }

  .mobile-close-content {
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px 16px 0;
    span {
      font-size: 14px;
      font-weight: 500;
      color: var(--color-29);
    }

    img {
      width: 16px;
      height: 16px;
    }
  }
}

@media screen and (max-width: 1440px) {
  .search-result-wrap {
    .search-result-content {
      height: calc(100vh - 120px);
    }
  }
}

@media screen and (max-width: 680px) {
  .search-result-wrap {
    height: 100vh;
    display: flex;
    flex-direction: column;
    .mobile-close-content {
    
    }

    .search-result-content {
      max-height: none;
      .search-input-wrap {
        margin-top: 20px;
      }
      
      .tokens {
        .tokens-title {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
